import React from 'react';

import Alert from './alert.svg?react';

function AlertIcon() {
  return <Alert style={{ verticalAlign: 'middle' }} />;
}

export default AlertIcon;
